<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Relatório de Estoque Consolidado
        </p>
      </div>
    </div>

    <div class="q-ml-md">
      <section
        style="margin-bottom: -20px"
        class="row col-12 q-mt-md q-gutter-sm text-brand-1 text-weight-bold"
      >
        <div class="col-md col-2">
          <div>Unidade:</div>
          <q-select
            dense
            outlined
            v-model="filtros.unidade"
            :options="listaUnidades"
            option-value="id"
            option-label="nome"
            map-options
            behavior="menu"
            use-input
            @filter="filtrarUnidades"
            :loading="loadingUnidades"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="white">Nenhum resultado</q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>

        <div class="col-md col-2">
          <div>Somente com saldo:</div>
          <q-select
            :options="opcoesComSaldo"
            label="Selecione"
            dense
            outlined
            v-model="filtros.com_saldo"
          />
        </div>

        <div class="col-md col-2">
          <div>Grupo de Produto:</div>
          <q-input outlined dense v-model="filtros.grupo_produto" />
        </div>

        <div class="col-md col-2">
          <div>Código Item:</div>
          <q-input outlined dense v-model="filtros.codigo_item" />
        </div>

        <div class="col-md col-2">
          <div>Descrição do Item:</div>
          <q-input outlined dense v-model="filtros.descricao_item" />
        </div>

        <div class="col-md q-mt-lg col-2">
          <q-btn
            color="secondary q-mt-sm"
            icon="filter_alt"
            no-caps
            label="Aplicar filtros"
            @click="aplicarFiltros"
            :loading="loading"
          />
        </div>
      </section>
    </div>

    <div style="margin-top: 40px">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span>Total de Produtos: {{ totalProdutos }}</span>
        <q-btn
          @click="exportarExcel"
          class="q-ml-sm"
          icon="file_upload"
          label="Exportar"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
          :loading="loadingExport"
          :disable="rows.length === 0"
        />
      </div>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rows"
        title-class="text-brand-5 text-weight-bold"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns"
        :loading="loading"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-Descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props" style="white-space: normal; word-break: break-word; max-width: 300px;">
            {{ props.row.Descricao }}
          </q-td>
        </template>

        <template v-slot:body-cell-quantidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ formatarQuantidade(props.row.Quantidade) }}
          </q-td>
        </template>

        <template v-slot:body-cell-Valor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ formatarValor(props.row.Valor) }}
          </q-td>
        </template>

        <template v-slot:body-cell-Total="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ formatarValor(props.row.Total) }}
          </q-td>
        </template>
      </q-table>

      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="loading"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome Unidade",
    field: "Nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Codigo",
    label: "Código Produto",
    field: "Codigo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Descricao",
    label: "Descrição Produto",
    field: "Descricao",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Unidadade_Medida",
    label: "Unidade Medida",
    field: "Unidadade_Medida",
    align: "center",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Grupo",
    label: "Nome Grupo",
    field: "Grupo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Familia",
    label: "Família",
    field: "Familia",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Valor",
    label: "Valor Unitário",
    field: "Valor",
    align: "right",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Quantidade",
    label: "Quantidade",
    field: "Quantidade",
    align: "right",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "Total",
    label: "Valor Total",
    field: "Total",
    align: "right",
    style: "color: #707070; font-weight: bold",
  },
];

export default {
  setup() {
    const store = useStore();
    const $q = useQuasar();

    const rows = ref([]);
    const loading = ref(false);
    const loadingExport = ref(false);
    const totalProdutos = ref(0);
    const listaUnidades = ref([]);
    const listaUnidadesCompleta = ref([]);
    const loadingUnidades = ref(false);

    const filtros = ref({
      unidade: { id: "", nome: "Todos" },
      com_saldo: { label: "Com Saldo", value: 1 },
      grupo_produto: "",
      codigo_item: "",
      descricao_item: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    // carregar as unidades
    const carregarUnidades = async () => {
      loadingUnidades.value = true;
      try {
        const resposta = await store.dispatch("org/listarUnidades", {});
        listaUnidadesCompleta.value = [
          { id: "", nome: "Todos" },
          ...resposta.listaUnidades,
        ];
        listaUnidades.value = [...listaUnidadesCompleta.value];
      } catch (error) {
        console.error("❌ Erro ao carregar unidades:", error);
      } finally {
        loadingUnidades.value = false;
      }
    };

    // filtrar unidades no select
    const filtrarUnidades = (val, update) => {
      update(() => {
        if (val === "") {
          listaUnidades.value = [...listaUnidadesCompleta.value];
        } else {
          const needle = val.toLowerCase();
          listaUnidades.value = listaUnidadesCompleta.value.filter(
            (v) => v.nome.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    };

    const buscarDados = async (page = 1, rowsPerPage = 15) => {
      loading.value = true;
      try {
        const filtroGrupoProduto = filtros.value.grupo_produto?.trim() || "";
        const filtroDescricaoItem = filtros.value.descricao_item?.trim() || "";

        const params = {
          com_saldo: filtros.value.com_saldo?.value ?? 1,
          per_page:
            filtroGrupoProduto || filtroDescricaoItem ? 15 : rowsPerPage,
          page: filtroGrupoProduto || filtroDescricaoItem ? 1 : page,
        };

        if (filtros.value.unidade && filtros.value.unidade.id) {
          params.vendor_id = filtros.value.unidade.id;
        }

        if (filtros.value.codigo_item && filtros.value.codigo_item.trim()) {
          params.cod_produto = filtros.value.codigo_item.trim();
        }

        const response = await store.dispatch(
          "estoque/listarEstoqueConsolidado",
          params
        );

        let dadosFiltrados = response.data.data || [];

        if (filtroGrupoProduto) {
          const filtroLowerCase = filtroGrupoProduto.toLowerCase();
          dadosFiltrados = dadosFiltrados.filter((item) => {
            const grupoItem = (item.Grupo || "").toLowerCase();
            return grupoItem.includes(filtroLowerCase);
          });
        }

        if (filtroDescricaoItem) {
          const filtroLowerCase = filtroDescricaoItem.toLowerCase();
          dadosFiltrados = dadosFiltrados.filter((item) => {
            const descricaoItem = (item.Descricao || "").toLowerCase();
            return descricaoItem.includes(filtroLowerCase);
          });
        }

        if (filtroGrupoProduto || filtroDescricaoItem) {
          const start = (page - 1) * rowsPerPage;
          const end = start + rowsPerPage;
          const totalFiltrado = dadosFiltrados.length;
          dadosFiltrados = dadosFiltrados.slice(start, end);

          rows.value = dadosFiltrados;
          totalProdutos.value = totalFiltrado;
          pagination.value.rowsPerPage = rowsPerPage;
          pagination.value.rowsNumber = totalFiltrado;
          pagination.value.page = page;
        } else {
          rows.value = dadosFiltrados;
          totalProdutos.value = response.data.total || 0;
          pagination.value.rowsPerPage = response.data.per_page;
          pagination.value.rowsNumber = response.data.total;
          pagination.value.page = response.data.current_page;
        }

        loading.value = false;
      } catch (error) {
        console.error("❌ Erro ao buscar dados:", error);
        $q.notify({
          message: "Erro ao buscar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        loading.value = false;
      }
    };

    const aplicarFiltros = () => {
      pagination.value.page = 1;
      buscarDados();
    };

    const exportarExcel = async () => {
      loadingExport.value = true;
      try {
        const params = {
          com_saldo: filtros.value.com_saldo?.value ?? 1,
          download: "excel",
        };

        if (filtros.value.unidade && filtros.value.unidade.id) {
          params.vendor_id = filtros.value.unidade.id;
        }

        if (filtros.value.grupo_produto) {
          params.grupo_produto = filtros.value.grupo_produto;
        }

        if (filtros.value.codigo_item) {
          params.cod_produto = filtros.value.codigo_item;
        }

        if (filtros.value.descricao_item) {
          params.search = filtros.value.descricao_item;
        }

        const response = await store.dispatch(
          "estoque/exportarEstoqueConsolidado",
          params
        );

        // criar link de download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `estoque_consolidado_${new Date().getTime()}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        $q.notify({
          message: "Exportado com Sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      } finally {
        loadingExport.value = false;
      }
    };

    const formatarQuantidade = (valor) => {
      if (!valor && valor !== 0) return "0,00";
      return parseFloat(valor).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const formatarValor = (valor) => {
      if (!valor && valor !== 0) return "R$ 0,00";
      return parseFloat(valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    watch(
      () => pagination.value.page,
      (newPage, oldPage) => {
        if (newPage !== oldPage) {
          buscarDados(pagination.value.page, pagination.value.rowsPerPage);
        }
      }
    );

    watch(
      () => filtros.value.unidade,
      (newVal, oldVal) => {
        if (
          newVal &&
          oldVal &&
          JSON.stringify(newVal) !== JSON.stringify(oldVal)
        ) {
          pagination.value.page = 1;
          buscarDados();
        }
      },
      { deep: true }
    );

    onMounted(async () => {
      await carregarUnidades();
      buscarDados();
    });

    return {
      filtros,
      rows,
      columns,
      loading,
      loadingExport,
      totalProdutos,
      pagination,
      listaUnidades,
      loadingUnidades,
      carregarUnidades,
      filtrarUnidades,
      buscarDados,
      aplicarFiltros,
      exportarExcel,
      formatarQuantidade,
      formatarValor,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      opcoesComSaldo: [
        {
          label: "Com Saldo",
          value: 1,
        },
        {
          label: "Sem Saldo",
          value: 0,
        },
        {
          label: "Todos",
          value: 2,
        },
      ],
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
theader tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap !important;
}

a {
  text-decoration: none;
}
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
